export default __webpack_public_path__ + "static/media/BO7 Home Gadgets.bf957924.jpeg";